import React from 'react';
import { X, RotateCcw } from 'lucide-react';
import { text, radius, typography } from '../design-system/tokens';

// KIQ Assistant — Fase 3. Header premium del panel: [marca] KIQ / Restaurant
// Intelligence / nombre del restaurante (SOLO si es real, nunca inventado —
// mismo criterio que RestauranteChip en Layout.js) / cerrar.
//
// Fase 3.1 — padding vertical levemente recortado (18px->15px, sección 8
// del pedido: "normalización de espaciado pequeña", nunca un rediseño) como
// parte de la reducción general de densidad vertical.
//
// Shell (design_handoff_shell) — marca 42px: la MISMA imagen real
// (/kiq-mark.png) que ya usan los banners de Finanzas/Ventas/Objetivos/
// Equipo y ahora también el sidebar/botón flotante (ver Layout.js/
// KIQButton.js) — nunca el placeholder SVG de KIQMark.js. Chip "EN LÍNEA"
// puramente decorativo (no representa un estado real de conexión — KIQ
// siempre "está ahí", nunca [backend]). Botón "reiniciar conversación"
// (nuevo — antes no existía): `onReiniciar` es opcional, KIQPanel lo pasa
// para limpiar el composer completo (ver KIQHome.js/KIQPanel.js) — no toca
// ningún endpoint, solo estado local del cliente.
export default function KIQHeader({ restauranteNombre, onReiniciar, onCerrar }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
      padding: '15px 20px', borderBottom: '1px solid var(--modal-border)', flexShrink: 0,
      background: 'var(--card-alt)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '11px', minWidth: 0 }}>
        <img src="/kiq-mark.png" alt="KIQ" style={{ width: '42px', height: '42px', flexShrink: 0, borderRadius: '13px', objectFit: 'cover', boxShadow: '0 10px 26px rgba(123,58,237,.45)' }} onError={(e) => { e.currentTarget.style.display = 'none'; }} />
        <div style={{ minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ ...typography.h3, color: text.primary, lineHeight: 1.1 }}>KIQ</span>
            <span style={{ display: 'flex', alignItems: 'center', gap: '5px', padding: '3px 8px', borderRadius: radius.sm, background: 'rgba(61,220,145,.14)', fontFamily: typography.fontFamilyMono, fontSize: '8.5px', fontWeight: 700, letterSpacing: '.1em', color: 'var(--success-text)' }}>
              <span style={{ width: '5px', height: '5px', borderRadius: '50%', background: '#3DDC91' }} />EN LÍNEA
            </span>
          </div>
          <div style={{ ...typography.bodySmall, color: text.muted, marginTop: '2px' }}>Restaurant Intelligence</div>
          {restauranteNombre && (
            <div style={{ fontSize: '11px', color: text.muted, marginTop: '2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {restauranteNombre}
            </div>
          )}
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '7px', flexShrink: 0 }}>
        {onReiniciar && (
          <button
            type="button"
            onClick={onReiniciar}
            className="kiq-focusable"
            aria-label="Reiniciar conversación"
            title="Reiniciar conversación"
            style={{
              width: '32px', height: '32px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: 'var(--card-hover)', border: '1px solid var(--border)', borderRadius: radius.md,
              color: text.muted, cursor: 'pointer',
            }}
          >
            <RotateCcw size={14} />
          </button>
        )}
        <button
          type="button"
          onClick={onCerrar}
          className="kiq-focusable"
          aria-label="Cerrar KIQ"
          style={{
            width: '30px', height: '30px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'var(--card-hover)', border: '1px solid var(--border)', borderRadius: radius.md,
            color: text.muted, cursor: 'pointer',
          }}
        >
          <X size={15} />
        </button>
      </div>
    </div>
  );
}
